exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editandowebsite{background-color:#f9fafb;border-color:#1e90ff5e;outline:0;box-shadow:inset 0 1px 2px rgb(46 54 80/8%),0 0 0 .2rem rgb(38 43 64/20%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50a6dd60","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/team-members.vue
// module id = 77
// module chunks = 0